import axios from 'axios'
import HTTP from '@rocketfid/api'
import { unsetResultsdone } from '../../services/contestround.api'

const state = {
  items: []
}

// getters
const getters = {
  rounds: (state) => {
    return state.items
  },
  roundById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  },
  getById: (state) => (id) => {
    return state.items.find(item => item.id === id)
  }
}

// actions
const actions = {
  loadRounds ({commit, dispatch, rootGetters}) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .round.getAll()
      .then((rounds) => {
        dispatch('rounds/resetRounds', null, { root: true })
        commit('ADD_ROUND_ITEMS', { items: rounds })
        return rounds
      })
  },

  loadRoundsByContest ({commit, dispatch, rootGetters}, {idContest}) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .round.getAllByContest(idContest)
      .then((rounds) => {
        dispatch('rounds/resetRounds', null, { root: true })
        commit('ADD_ROUND_ITEMS', { items: rounds })
        return rounds
      })

      // let url = process.env.API + '/contest/' + contest.id + '/contestround/' + page + '/' + pagination + '/'
  },

  loadRound ({ commit, rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .round.get(id)
      .then((round) => {
        commit('UPDATE_ROUND_ITEM', { item: round })
        return round
      })
  },

  resetRounds ({ commit }) {
    return new Promise((resolve, reject) => {
      commit('RESET_ROUND_ITEMS')
      resolve()
    })
  },

  addRound ({ commit, rootGetters }, { round }) {
    let sitekey = rootGetters['account/currentSitekey']

    // round.allgoodbonus = 10

    return HTTP
      .setInstance(sitekey)
      .round.create(round)
      .then((round) => {
        commit('ADD_ROUND_ITEM', { item: round })
        return round
      })
  },

  addResponses ({ commit }, { round, responses, sitekey }) {
    return new Promise((resolve, reject) => {
      const url = process.env.API + '/contestround/' + round.id + '/roundresponses/'
      const headers = {headers: { 'X-Instance': sitekey }}

      axios.post(url, responses, headers).then(response => {
        let round = response.data
        commit('UPDATE_ROUND_ITEM', { item: round })
        resolve(round)
      }).catch(e => {
        reject(e)
      })
    })
  },

  updateRound ({ commit, rootGetters }, { round }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .round.update(round)
      .then((round) => {
        commit('UPDATE_ROUND_ITEM', { item: round })
        return round
      })
  },

  refreshRound ({ commit, dispatch }, { round, sitekey }) {
    return new Promise((resolve, reject) => {
      const url = process.env.API + '/contestround/' + round.id + '/'
      const headers = {headers: { 'X-Instance': sitekey }}

      axios.get(url, headers)
        .then((response) => {
          let round = response.data
          round.sitekey = sitekey
          commit('UPDATE_ROUND_ITEM', { item: round })
          resolve(round)
        }).catch((e) => {
          reject(e)
        })
    })
  },
  removeRound ({ commit, rootGetters }, { round }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .round.delete(round)
      .then((round) => {
        commit('REMOVE_ROUND_ITEM', { item: round })
        return round
      })
  },
  async unsetResultsdone ({ commit, rootGetters }, { round }) {
    let sitekey = rootGetters['account/currentSitekey']
    const newRound = await unsetResultsdone(sitekey, round.id)
    console.log(newRound)
    commit('UPDATE_ROUND_ITEM', { item: newRound })
    return newRound
  }
}

// mutations
const mutations = {
  ADD_ROUND_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_ROUND_ITEMS: (state) => {
    state.items = []
  },

  ADD_ROUND_ITEM: (state, { item }) => {
    state.items.push(item)
  },

  UPDATE_ROUND_ITEM: (state, { item }) => {
    let find = false

    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
        find = true
      }
    }

    if (!find) {
      state.items.push(item)
    }
  },
  REMOVE_ROUND_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/rounds.js